import React, { CSSProperties } from 'react';
import { IStackItemProps } from '../types';

const convertToCSSValue = (value: boolean | number | string): string => {
  if (typeof value === 'boolean') {
    return value ? '1' : '0';
  }
  return value.toString();
};

export const Item: React.FC<React.PropsWithChildren<IStackItemProps>> = (props) => {
  const { children, className, basis, align, shrink, grow, verticalFill, order, width } = props;

  // assign alignment styles
  const stackItemStyles: CSSProperties = {
    paddingInline: 'inherit',
    ...(shrink && { flexShrink: convertToCSSValue(shrink) }),
    ...(align && { alignSelf: convertToCSSValue(align) }),
    ...(grow && { flexGrow: convertToCSSValue(grow) }),
    ...(basis && { flexBasis: convertToCSSValue(basis) }),
    ...(order && { order: convertToCSSValue(order) }),
    ...(verticalFill && { height: '100%' }),
    ...(width && { width: convertToCSSValue(width), flexShrink: 0 }),
  };

  return (
    <div
      className={className}
      style={stackItemStyles}
    >
      {children && children}
    </div>
  );
};
